import { useState } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import {
  LayoutDashboard,
  Users,
  Settings,
  LogOut,
  Menu,
  HeartPulse,
  FileText,
  Calculator
} from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar"
import { AppSidebar } from "./AppSidebar"
import { Toaster } from "@/components/ui/toaster"

export function AppLayout() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <main className="w-full">
        <div className="h-14 px-4 border-b flex items-center gap-4 bg-white">
          <SidebarTrigger />
          <div className="font-semibold text-lg">Cardiology Risk Score</div>
        </div>
        <div className="p-8 max-w-7xl mx-auto">
          <Outlet />
        </div>
      </main>
      <Toaster />
    </SidebarProvider>
  );
}
